import * as React from "react";
import { useCallback } from "react";
import { useUser } from "../user/useUser";
import { useUserMenu } from "../UserMenu/useUserMenu";
import { useMenu } from "./useMenu";

export function Logout() {
  const { logoutRequest } = useUser();
  const { closeUserMenu } = useUserMenu();

  const logout = useMenu().items.logout;

  const onClickOnLogout = useCallback(() => {
    closeUserMenu();
    logoutRequest();
  }, [closeUserMenu, logoutRequest]);

  return (
    <ul className="elm-list-none elm-m-0 elm-p-0">
      <li key="logout" className="elm-border-gray-300 elm-border-0 elm-border-b elm-border-solid">
        <button
          className="focus:elm-outline-none elm-px-6 elm-font-sans elm-pointer-events-auto elm-w-full elm-justify-start elm-flex elm-bg-transparent elm-border-0 elm-text-dd-gray-900 elm-text-lg elm-transition elm-no-underline elm-py-4 lg:hover:elm-text-dd-blue-800 elm-cursor-pointer"
          onClickCapture={onClickOnLogout}
          title={logout.label}
          aria-label={logout.label}
        >
          {logout.label}
        </button>
      </li>
    </ul>
  );
}
